import { useContext } from 'react';
import { DialogTitle, DialogContent, DialogActions, Grid } from '@mui/material';
import { useModal } from 'components/Modals';
import { useForm } from 'react-hook-form';
import { DropsContext } from 'contexts/DropsContext';
import { AnuncioContext } from 'contexts/AnuncioContext';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';

const ImportModal = ({ callback }) => {
  const defaultValues = { integra_access_id: null };
  const { closeModal } = useModal();
  const { control, handleSubmit } = useForm({ defaultValues });
  const { drops } = useContext(DropsContext);
  const { postLoading, importAnuncio } = useContext(AnuncioContext);

  const onSubmit = (data) => importAnuncio({ data, cb: callback });

  return (
    <>
      <DialogTitle>Importar Anúncios</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} />
          <Grid item xs={12}>
            <Dropdown
              label="Loja"
              control={control}
              name="integra_access_id"
              options={drops?.IntegraAccess}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit(onSubmit)} loading={postLoading}>
          Confirmar
        </Button>
        <Button onClick={closeModal} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default ImportModal;
